<template>
  <v-container class="gewerbestep1 pa-0">

    <h1 class="ueberplus primary--text">Angebot Rechtsschutz für Gewerbetreibende/Selbstständige</h1>

    <!-- PKS: Select makler and tarif --------------------------------------------->
    <select-tarif v-if="selectTarifAllowed"
                  state-path="gewerbe"
                  gewerbe />

    <div class="semanticsection-title2 primary--text">Firma</div>
    
    <firma-basis :state-path="$store.getters.personPath('vn1')"
                 :reset-branchen="resetBranchen"
                 :reset-rechtsformen="resetRechtsformen"
                 :unused="['adresse', 'kontakt', 'hr']" />

    <!-- Filialen -->
    <v-row no-gutters class="mt-4">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Filialen vorhanden?
          <site-tooltip titel="Filialen">
            <strong>Rechtlich unselbstständige</strong> Unternehmen/Betriebsstätten (z.B. Filiale) des Versicherungsnehmers innerhalb Deutschlands sind beitragsfrei mitversichert. Bitte machen Sie zu den weiteren Unternehmen entsprechende Angaben. 
            Bei der Berechnung des Beitrags (Anzahl Fahrzeuge bzw. Mitarbeiter) sind alle zu versichernden Unternehmen/Betriebsstätten zu berücksichtigen.<br>
            Rechtlich selbstständige Unternehmen sind grundsätzlich separat zu versichern.<br/>
            Bei Fragen rufen Sie gerne die Makler-Hotline unter (+49) 02 21 / 37 638 - 92 an. 
          </site-tooltip>
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-radio-group v-model="hasFilialen"
                       row
                       hide-details
                       class="pa-0" >
          <v-radio label="Ja"
                   name="hasfilialenyes"
                   :value="true"/>
          <v-radio label="Nein"
                   name="hasfilialenno"
                   :value="false"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <template v-if="hasFilialen">
      <v-row no-gutters class="mt-4">
        <v-col cols="12"
               sm="6" />
        <v-col cols="12"
               sm="6" >
          <v-text-field v-model="anzahlFilialen"
                        v-validate="'required|numeric|min_value:1|max_value:10'"
                        :error-messages="errors.collect('anzahlFilialen')"
                        data-vv-as="Anzahl Filialen"
                        data-vv-name="anzahlFilialen"
                        label="Anzahl Filialen"
                        class="required"
                        @input="direktionsAnfrage('anzahlFilialen','Filialen','10','max_value')" />
        </v-col>
      </v-row>
    </template>

    <!-- Mitversicherte Unternehmen -->
    <v-row no-gutters class="mt-4">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Weiteres Unternehmen mitversichern?
          <site-tooltip titel="Weiteres Unternehmen">
            <strong>Rechtlich unselbstständige</strong> Unternehmen/Betriebsstätten (z.B. Filiale) des Versicherungsnehmers innerhalb Deutschlands sind beitragsfrei mitversichert. Bitte machen Sie zu den weiteren Unternehmen entsprechende Angaben. 
            Bei der Berechnung des Beitrags (Anzahl Fahrzeuge bzw. Mitarbeiter) sind alle zu versichernden Unternehmen/Betriebsstätten zu berücksichtigen.<br>
            Rechtlich selbstständige Unternehmen sind grundsätzlich separat zu versichern.<br/>
            Bei Fragen rufen Sie gerne die Makler-Hotline unter (+49) 02 21 / 37 638 - 92 an. 
          </site-tooltip>
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-radio-group v-model="hasMvUnternehmen"
                       row
                       hide-details
                       class="pa-0"
                       @change="activateMvUnternehmen">
          <v-radio label="Ja"
                   :value="true"/>
          <v-radio label="Nein"
                   :value="false"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <template v-if="hasMvUnternehmen">

      <dmb-accordion ref="accordionStep1mvu"
                     :items="mvUnternehmen"
                     component-name="FirmaBasis"
                     :child-props="{ unused: ['adresse', 'kontakt', 'hr'], resetBranchen, resetRechtsformen }"
                     :allow-delete="true"
                     state-path="gewerbe.ui.accordions.step1Mvu"
                     @remove="removeMvUnternehmen(...arguments)"/>

      <add-button text="weiteres Unternehmen hinzufügen"
                 @add="addMvUnternehmen" />

    </template>

    <!-- Laufzeit -->
    <div class="semanticsection-title2 primary--text">Laufzeit</div>

    <v-radio-group v-model="laufzeit"
                   row
                   hide-details
                   name="laufzeit"
                   class="pa-0 fixedwidthlabel"
                   @change="updatePrices" >
      <v-radio value="1"
               label="ein Jahr" />        
      <v-radio value="3"  
               label="drei Jahre (5 % Laufzeit-Rabatt)" />
    </v-radio-group>

    <!-- Versicherungsschutz Privater Bereich -->
    <div class="semanticsection-title2 align--center">
      <span class="primary--text mr-1">Versicherungsschutz für den privaten Bereich</span>
      <site-tooltip>
        Damit ist Ihr selbstständiger Kunde mit seiner Familie auch im privaten Bereich umfassend abgesichert in den Bereichen Privat (z.B. private Versicherungen, private Verträge), Beruf (im privaten Bereich als Arbeitnehmer) , Verkehr (privat genutzte Fahrzeuge) und Wohnen (für zwei selbstgenutzte Wohneinheiten in Deutschland).
      </site-tooltip>
    </div>
    <div class="kompex-container">
      <v-radio-group v-model="isKompex"
                     v-validate="'required'"
                     :error-messages="errors.collect('isKompex')"
                     :disabled="!isAvailable('SPEZ-PBV+MIET')"
                     data-vv-as="Privater Versicherungsschutz"
                     data-vv-name="isKompex"
                     row
                     hide-details
                     class="pa-0 fixedwidthlabel"
                     @change="resetMatrixSelection" >
        <v-radio label="Ja"
                 :value="true" />
        <v-radio label="Nein"
                 :value="false" />
      </v-radio-group>
      <div v-if="!isAvailable('SPEZ-PBV+MIET')"
           class="kompex-overlay"
           @click="showDirektionsanfrageSnackbar('SPEZ-PBV+MIET')"></div>
    </div>

    <!-- Versicherungsschutz Firma -->
    <div class="semanticsection-title2 primary--text">Versicherungsschutz für den geschäftlichen Bereich</div>

    <v-row justify="start"
           no-gutters
           class="disabled-direktionsanfrage" >
      <v-checkbox v-model="produkteModel"
                  v-validate.disable="'required'"
                  :error-messages="errors.collect('produkte')"
                  data-vv-as="Versicherungsschutz für die Firma"
                  data-vv-name="produkte"
                  name="produkte"
                  :disabled="produkteDisabled || !isAvailable('FIRM')"
                  label="Firma/Gewerbe"
                  value="FIRM"
                  class="mr-6 mb-0 produkte"
                  @change="resetMatrixSelection"
                  @click="showDirektionsanfrageSnackbar('FIRM')" />
      <v-checkbox v-model="produkteModel"
                  v-validate.disable="'required'"
                  :error-messages="errors.collect('produkte')"
                  hide-details
                  data-vv-as="Versicherungsschutz für die Firma"
                  data-vv-name="produkte"
                  name="produkte"
                  :disabled="produkteDisabled || !isAvailable('VERK')"
                  label="Verkehr"
                  value="VERK"
                  class="mr-6 mb-0"
                  @change="resetMatrixSelection"
                  @click="showDirektionsanfrageSnackbar('VERK')" />
      <v-checkbox v-model="produkteModel"
                  v-validate.disable="'required'"
                  :error-messages="errors.collect('produkte')"
                  hide-details
                  data-vv-as="Versicherungsschutz für die Firma"
                  data-vv-name="produkte"
                  name="produkte"
                  :disabled="produkteDisabled || !isAvailable('MIET')"
                  label="Immobilie"
                  value="MIET"
                  class="mb-0"
                  @change="resetMatrixSelection"
                  @click="showDirektionsanfrageSnackbar('MIET')" />
    </v-row>

    <template v-if="isKompex && isAvailable('SPEZ-PBV+MIET') || hasProdukt('FIRM')">
      <div class="semanticsection-title2 primary--text">Rechtsschutz für Firmen, Berufs-Rechtsschutz für Selbstständige
        <span class="dmb-inline-nowrap">(§ {{ (isKompex) ? "28" : "24" }} ARB)</span>
      </div>

      <mitarbeiter-data state-path="gewerbe.mitarbeiter" @pricechanged="updatePrices" />
    </template>

    <template v-if="(!isKompex || !isAvailable('SPEZ-PBV+MIET')) && hasProdukt('VERK')">
      <fahrzeug-data state-path="gewerbe.fahrzeuge" @pricechanged="updatePrices" />
    </template>

    <template v-if="showImmobilien">
      <div class="semanticsection-title2 primary--text">Gewerblicher Immobilien-Rechtsschutz <span class="dmb-inline-nowrap">(§ 29 ARB)</span></div>

      <dmb-accordion ref="accordionStep1Immo"
                 :items="immobilien"
                 component-name="immobilieData"
                 :allow-delete="true"
                 state-path="gewerbe.ui.accordions.step1Immo"
                 @remove="removeImmobilie(...arguments)"/>

      <add-button text="Immobilie hinzufügen"
                  @add="addImmobilie" />
    </template>

    <v-row no-gutters class="stepperbuttons">
      <v-spacer/>
      <v-btn color="primary"
             class="standard-button"
             @click="stepForward">Weiter</v-btn>
    </v-row>

    <v-overlay v-model="noOfferDialog.show"
               z-index="200"/>
    <v-dialog v-model="noOfferDialog.show"
              width="500"
              hide-overlay
              persistent >
      <v-card class="round-corners black87 dmb-form-text pa-6">
        <v-row justify="center"
               no-gutters >
          <div class="ueber">Angebotserstellung nicht möglich</div>
          <v-col cols="12" class="my-6">
            Ein Online-Angebot kann für diese {{ noOfferDialog.label }} nicht erstellt werden. Bitte wenden Sie sich an unseren Maklerservice unter
            <span class="font-weight-medium" style="white-space: nowrap">(+49) 02 21 / 37 638 - 92</span> oder an
            <span class="font-weight-medium" style="white-space: nowrap">maklerservice@dmb-rechtsschutz.de</span>. Vielen Dank.
          </v-col>
          <v-btn color="primary"
                 class="standard-button"
                 @click="noOfferDialog.show = false">Ok
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import FirmaBasis from '../gewerberechner/FirmaBasis';
import DmbAccordion from '../gewerberechner/DmbAccordion';
import AddButton from '../gewerberechner/AddButton';
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import MitarbeiterData from './MitarbeiterData';
import FahrzeugData from './FahrzeugData';
import SelectTarif from '../privatkundenrechner/SelectTarif';
import { mapGetters } from 'vuex';
import rechtsform from '../../store/config/companyLegalform';
import { RIGHTS } from '../../store/user';

export default {
  name: "GewerbeStep1",
  components: { FahrzeugData, MitarbeiterData, DmbAccordion, AddButton, FirmaBasis, SelectTarif },
  mixins: [ twowayBindingMixin, ValidationMixin ],
  data() {
    return {
      noOfferDialog: {
        show: null,
        label: ''
      },
      otherRechtsform: rechtsform.other.code,
      resetRechtsformen: [],
      resetBranchen: []
    };
  },
  computed: {
    selectTarifAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    },
    mvUnternehmen() {
      return this.$store.getters.mvUnternehmen.map((mvu, i) => {
        return {
          key: mvu.key,
          label: `${i + 1}. weiteres Unternehmen`,
          name: (mvu.name || "")  + " " + (mvu.rechtsform || ""),
          statePath: this.$store.getters.personPath(mvu.key)
        };
      });
    },
    branchen() {
      let branchen = [];
      if (this.versicherungsnehmer.branche.code) branchen.push(this.versicherungsnehmer.branche.code);
      if (this.hasMvUnternehmen) {
        branchen = branchen.concat(this.$store.getters.mvUnternehmen.filter(mvu => !!mvu.branche.code).map(mvu => mvu.branche.code));
      }
      return branchen;
    },
    rechtsformen() {
      let rechtsformen = [];
      if (this.versicherungsnehmer.rechtsform) rechtsformen.push(this.versicherungsnehmer.rechtsform);
      if (this.hasMvUnternehmen) {
        rechtsformen = rechtsformen.concat(this.$store.getters.mvUnternehmen.filter(mvu => !!mvu.rechtsform).map(mvu => mvu.rechtsform));
      }
      return rechtsformen;
    },
    produkteModel: {
      get() {
        return this.isKompex && this.isAvailable('SPEZ-PBV+MIET') ? this.$store.state.gewerbe.ui.isKompexOhneI
            ? ['FIRM', 'VERK'] : ['FIRM', 'VERK', 'MIET'] : this.produkte;
      },
      set(produkte) {
        if (!this.isKompex || !this.isAvailable('SPEZ-PBV+MIET')) {
          this.produkte = produkte;
          this.$validator.validate('produkte');
        }
      }
    },
    produkteDisabled() {
      return this.isKompex && this.isAvailable('SPEZ-PBV+MIET');
    },
    immobilien() {
      return this.$store.state.gewerbe.immobilien.map((immo, i) => {
        return {
          key: immo.key,
          label: `Immobilie ${i + 1}`,
          name: immo.name,
          statePath: this.$store.getters.immobiliePath(immo.key)
        };
      });
    },
    showImmobilien() {
      let show = (!this.isKompex || !this.isAvailable('SPEZ-PBV+MIET')) && this.hasProdukt('MIET');
      if (show && this.immobilien.length === 0) {
        this.activateImmobilien();
      }
      return show;
    },
    ...mapTwoWay([
      'laufzeit',
      'produkte'
    ], {}, 'gewerbe.vertrag'),
    ...mapTwoWay([
      'hasFilialen',
      'hasMvUnternehmen',
      'isKompex',
      'produkte'
    ], {}, 'gewerbe.ui'),
    ...mapTwoWay([
      'anzahlFilialen'
    ],
      {}, 'gewerbe.personen.0'), // this is always vn1
    ...mapGetters([
      'gewerbeProductAvailable',
      'gewerbeProductSelected',
      'versicherungsnehmer',
      'checkAuthorizationPKS'
    ])
  },
  watch: {
    branchen(newvalue, oldvalue) {
      if (this.isKompex) this.isKompex = this.isAvailable('SPEZ-PBV+MIET');
      if (this.produkte.length > 0) this.produkte = this.produkte.filter(p => this.isAvailable(p));
      if (this.gewerbeProductSelected('SPEZ-SSRG', 'vn1') && !this.isAvailable('SPEZ-SSRG')) this.resetMatrixSelection();

      // reset selection if no products are available
      if (newvalue.length >= oldvalue.length) {
        const products = ['FIRM', 'VERK', 'MIET', 'SPEZ-PBV+MIET'];
        let productsAvailable = false;
        for (let i=0; i < products.length; i++) {
          if (this.isAvailable(products[i])) {
            productsAvailable = true;
            break;
          }
        }
        if (!productsAvailable) {
          const diff = newvalue.filter(b => !oldvalue.includes(b));
          if (diff.length > 0) {
            this.resetBranchen = diff;
            this.noOfferDialog = {
              show: true,
              label: 'Branche'
            };
          }
        }
      }
    },
    rechtsformen() {
      if (this.rechtsformen.find(r => r === this.otherRechtsform)) {
        this.noOfferDialog = {
          show: true,
          label: 'Rechtsform'
        };
        this.resetRechtsformen = [this.otherRechtsform];
      }
    }
  },
  methods: {
    direktionsAnfrage(fieldname, label, limit, rule) {
        this.$validator.validate(fieldname).then((result) => {
        if(!result) fnError();
      });
      const fnError = (function(){
          const maxerror = this.errors.items.filter(
            (er) => er.rule === rule);
          if( maxerror.length) {
            this.$store.dispatch('gewerbeShowDirektionsanfrage', {
              label: label,
              limit: limit
            });
          }
      }).bind(this);
    },
    activateMvUnternehmen() {
      if (this.hasMvUnternehmen && this.mvUnternehmen.length === 0) this.addMvUnternehmen();
    },
    activateImmobilien() {
      if ((!this.isKompex || !this.isAvailable('SPEZ-PBV+MIET')) && this.hasProdukt('MIET') && this.immobilien.length === 0) this.$store.commit('addImmobilie');
    },
    addMvUnternehmen() {
      let limit = 5;
      if ( this.mvUnternehmen.length + 1 > limit ) {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', { label: 'weitere Unternehmen', limit });
      } else {
        this.$store.commit('addMvUnternehmen');
      }
    },
    removeMvUnternehmen(key, index) {
      this.$store.commit('removePerson', { key: key, index: index });
    },
    addImmobilie() {
      let limit = 5;
      if ( this.immobilien.length + 1 > limit ) {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', {
          label: 'Immobilien',
          limit
        });
      } else {
        this.$store.commit('addImmobilie');
      }
    },
    removeImmobilie(key) {
      this.$store.dispatch('gewerbeRemoveImmobilie', { key: key });
    },
    hasProdukt (p) {
      return this.produkte.indexOf(p) > -1;
    },
    stepForward () {
      this.$emit('step-forward');
    },
    isAvailable(produkt) {
      return this.gewerbeProductAvailable(this.$store.state.gewerbe.personen, this.hasMvUnternehmen, produkt);
    },
    showDirektionsanfrageSnackbar(produkt) {
      if (produkt === 'SPEZ-PBV+MIET' || !this.produkteDisabled && !this.isAvailable(produkt)) {
        if(produkt === 'SPEZ-PBV+MIET'){
          this.$store.dispatch('gewerbeShowDirektionsanfrage', { intro: 'Der Versicherungsschutz für den privaten Bereich kann nicht angeboten werden.'} );
        } else if(produkt === 'FIRM'){
          this.$store.dispatch('gewerbeShowDirektionsanfrage', { intro: 'Der Versicherungsschutz für den Firmen-/Gewerbe-Rechtsschutz kann nicht angeboten werden.'} );
         } else if(produkt === 'VERK'){
          this.$store.dispatch('gewerbeShowDirektionsanfrage', { intro: 'Der Versicherungsschutz für den Verkehrs-Rechtsschutz kann nicht angeboten werden.'} );
         } else if(produkt === 'MIET'){
          this.$store.dispatch('gewerbeShowDirektionsanfrage', { intro: 'Der Versicherungsschutz für den Immobilien-Rechtsschutz kann nicht angeboten werden.'} );
        } else {
          this.$store.dispatch('gewerbeShowDirektionsanfrage');
        }
      }
    },
    resetMatrixSelection() {
      if (this.$store.state.gewerbe.ui.matrixSelection.produkte.length > 0) {
        this.$store.dispatch('gewerbeResetMatrixSelection');
      }
    },
    updatePrices() {
      if (this.$store.state.gewerbe.ui.matrixSelection.produkte.length > 0) {
        this.$store.dispatch('gewerbeUpdateMatrixDeckung', this.$store.state.gewerbe.ui.matrixSelection);
      }
    }
  }
};
</script>
<style>
.gewerbestep1 .produkte .v-messages {
  max-width: 100px;
  white-space: nowrap;
}

.gewerbestep1 .disabled-direktionsanfrage .v-input--is-disabled {
  pointer-events: initial!important;
}

.gewerbestep1 .disabled-direktionsanfrage .v-input--is-disabled .v-icon {
  cursor: pointer;
  /*stepper header has z-index 5*/
  z-index: 4;
}

.gewerbestep1 .kompex-container {
  position: relative;
}

.gewerbestep1 .kompex-container .kompex-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 220px;
  background: transparent;
  cursor: pointer;
}

.gewerbestep1 .fixedwidthlabel .v-radio:first-child label{
  width: 65px !important;
}

.gewerbestep1 .produkte label{
  width: 120px !important;
}
</style>
